<div class="container py-2 carousel-container">
  <div class="row min-vh-100">
    <div class="w-100" id="slider">
      <div id="myCarousel" class="carousel slide" data-interval="false">
        <div>
          <div *ngIf="!isFinalized" class="editor-action left-10">
            <i class="fas fa-trash icon-pencil" *ngIf="isShow"
              [ngClass]="{ 'not-allowed': workStatus === 'inprogress', 'd-none': isLockedRO}"
              (click)="deleteMedia(); $event.stopPropagation()"></i>
          </div>
          <div class="editor-action">
            <i class="fal fa-times icon-pencil" (click)="close(); $event.stopPropagation()"></i>
          </div>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item" [class]="_activeIndex === i ? 'active' : ''"
            *ngFor="let imageSlider of galleryItems; let i = index">
            <div class="img-container" *ngIf="imageSlider?.type === 'image'"
              [class]="imageSlider?.type === 'image' && imageSlider?.notes ? 'has-caption' : ''">
              <!-- <img class="" [src]="imageSlider?.url" [alt]="imageSlider.name" /> -->

              <div *ngIf="screenSize?.width < 1024; else largeScreen">
                <pinch-zoom *ngIf="imageViewer" [index]="_activeIndex">
                  <img [src]="imageViewer[_activeIndex]" />
                </pinch-zoom>
              </div>

              <ng-template #largeScreen>
                <angular-image-viewer *ngIf="imageViewer" [index]="_activeIndex" [src]="imageViewer" [config]="config"
                  (indexChange)="handleEvent($event)">
                </angular-image-viewer>
              </ng-template>


            </div>

            <div class="img-container" *ngIf="imageSlider?.type === 'video'" (click)="$event.stopPropagation()">
              <video controls [id]="imageSlider._id">
                <source [src]="imageSlider?.url" type="video/mp4">
              </video>
            </div>

            <div class="img-container flex-start-center flex-wrap inspection-media-wrapper"
              *ngIf="imageSlider?.type === 'voice'">
              <div class="inspection-media flex-column flex-center-center voice-media-wrapper">
                <div class="voice-media-row mb-1">
                  <div [hidden]="!imageSlider.isPlaying" class="inspection-media flex-column flex-center-center"
                    (click)="pauseAudio(imageSlider, imageSlider._id)">
                    <i class="fas fa-pause font-bold text-white"></i>
                  </div>
                  <div [hidden]="imageSlider.isPlaying" class="inspection-media flex-column flex-center-center"
                    (click)="handlePlayAudio(imageSlider, imageSlider._id)">
                    <i class="fas fa-play text-white"></i>
                  </div>
                  <div class="progress-bar-wrapper">
                    <span *ngIf="!imageSlider.isPlaying" class="progress-text">
                      00:00 /
                      {{ renderRecordingTime(imageSlider.recordingTime) }}
                    </span>
                    <span *ngIf="imageSlider.isPlaying" class="progress-text">
                      {{ renderRecordingTime(playingTime) }} /
                      {{ renderRecordingTime(imageSlider.recordingTime) }}
                    </span>
                    <div class="progress-bar-placeholder">
                      <div *ngIf="imageSlider.isPlaying" class="progress-bar"
                        [ngStyle]="{ width: (playingTime / imageSlider.recordingTime) * 100 + '%' }"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="isUploading" class="inspection-media flex-center-center mr-2 mt-2">
                <i class="fal fa-spinner rotate"></i>
              </div>
            </div>

            <div class="nav-container justify-content-center" *ngIf="galleryItems.length>1">
              <button type="button" class="nav-change-button" (click)="changeIndex(true)"
                [ngClass]="disableNavigation(true) ? 'disable' : 'enable'">
                <span class="fa-caret-left fas">
                </span></button>

              <button type="button" class="nav-change-button"
                [ngClass]="disableNavigation(false) ? 'disable' : 'enable'" (click)="changeIndex(false)">
                <span class="fa-caret-right fas">
                </span></button>
            </div>
            <div class="carousel-caption-image" *ngIf="imageSlider?.type === 'image' && imageSlider?.notes">
              <p class="m-0">
                {{ imageSlider?.notes }}
              </p>
            </div>
          </div>
        </div>

        <div class="thumbnail-scroll-wrapper">
          <ul class="carousel-indicators list-inline mx-auto px-2 mb-0">
            <li class="list-inline-item" [class]="_activeIndex === i ? 'active' : ''" (click)="getIndex(item)"
              *ngFor="let item of galleryItems; let i = index">
              <a id="carousel-selector-0" [class]="_activeIndex === i ? 'selected' : ''" data-target="#myCarousel">
                <div *ngIf="item.type === 'video'" class="inspection-media media-item">
                  <div class="playVideo">
                    <i class="fa fa-play"></i>
                  </div>
                  <!-- <video *ngIf="item.url && isAppleDevice" class="inspection-item-image" playsinline muted autoplay -->
                  <!-- (click)="autoPlayTrigger(item._id)" -->
                  <!-- <source [src]="item.url" type="video/mp4" />
                  </video> -->
                  <video *ngIf="item.url" class="inspection-item-image">
                    <!-- (click)="autoPlayTrigger(item._id)" -->
                    <source [src]="item.url" type="video/mp4" />
                  </video>
                </div>
                <div *ngIf="item.type === 'voice'" class="inspection-media media-item"
                  [class]="_activeIndex === i ? 'font-primary' : 'font-white'">
                  <div [hidden]="item.isPlaying">
                    <i class="fal fa-play font-18"></i>
                  </div>
                  <span *ngIf="!item.isPlaying">{{ renderRecordingTime(item.recordingTime) }}</span>
                  <span *ngIf="item.isPlaying">{{ renderRecordingTime(playingTime) }}</span>
                  <div *ngIf="item.isPlaying" class="progress-bar"
                    [ngStyle]="{ width: (playingTime / item.recordingTime) * 100 + '%' }"></div>
                </div>

                <div class="img-thumbnail-container media-item" *ngIf="item.type === 'image'"
                  [style.backgroundImage]="'url(' + item?.url + ')'"></div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>